import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ArrowUp.svg",
  "use": "ArrowUp.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"ArrowUp.svg\"><path d=\"M45.6174,28.4542,34.01,16.8414V52.0208a2,2,0,1,1-4,0V16.8754L18.4374,28.4542a2.0009,2.0009,0,0,1-2.8289-2.83l15.0044-15.012a2,2,0,0,1,2.8291,0l15.0045,15.012a2.0009,2.0009,0,0,1-2.8291,2.83Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol